export default __webpack_public_path__ + "static/media/p03 p04.74494995.jpg";